// redux/slices/userSlice.js
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SupportMessage } from "@/components/CustomerSupport/supportMessages";

interface User {
  _id: string;
  name: string;
  email: string;
  phoneNumber: string;
  orders: string[];
  location:{
    city: string;
    country: string;
  }
}

export type Message = SupportMessage;


interface UserState {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  customerCareChatId: string | null;
  customerCareMessages: Message[];
}

const initialState: UserState = {
  user: null,
  token: null,
  refreshToken: null,
  customerCareChatId: null,
  customerCareMessages: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<{ user: User; token: string; refreshToken: string | null }>) => {
      if (state.user?._id !== action.payload.user._id) {
        state.customerCareChatId = null;
        state.customerCareMessages = [];
      }
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.customerCareMessages = state.customerCareMessages || [];
    },
    setTokens: (state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) => {
      state.token = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setCustomerCareChatId: (state, action: PayloadAction<string | null>) => {
      state.customerCareChatId = action.payload;
    },
    setCustomerCareMessages: (state, action: PayloadAction<Message[]>) => {
      state.customerCareMessages = action.payload || [];
    },
    addCustomerCareMessage: (state, action: PayloadAction<Message>) => {
      state.customerCareMessages = state.customerCareMessages || [];
      state.customerCareMessages.push(action.payload);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.customerCareChatId = null;
      state.customerCareMessages = [];
    },
  },
});

export const { setUser, setTokens, setCustomerCareChatId, setCustomerCareMessages, addCustomerCareMessage, logout } = userSlice.actions;
export default userSlice.reducer;
